import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import AttrOutputRadio from '@blade-sxp/task-management/components/visitors-portrait/attr-output-radio.vue';
let AttrOutput = class AttrOutput extends Vue {
    config;
    radios;
    chagneRadio() {
        this.$emit('input', this.config);
        this.$emit('update:config', this.config);
    }
};
__decorate([
    Prop()
], AttrOutput.prototype, "config", void 0);
__decorate([
    Prop()
], AttrOutput.prototype, "radios", void 0);
AttrOutput = __decorate([
    Component({
        name: 'AttrOutput',
        components: { AttrOutputRadio },
        i18n: {
            messages: {
                zh: {
                    outputTips: '年龄建议使用人脸属性结果，性别建议使用人体属性结果',
                },
                en: {
                    outputTips: 'For age, it is recommended to use the face attribute result, and for gender, it is recommended to use the body attribute result',
                },
            },
        },
    })
], AttrOutput);
export default AttrOutput;
